"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getConditionalExceptionClauseTypeOptions() {
    //******** MUST READ ********//
    // Must keep in order by dropdown section!
    return [
        // Addresses
        'from',
        'to',
        // My name is
        'onTheToLine',
        'onTheCcLine',
        'onTheToOrCcLine',
        'notOnTheToLine',
        'theOnlyRecipientListed',
        // Subject
        'subjectIncludes',
        'subjectOrBodyIncludes',
        // Includes these words
        'inTheBody',
        'inTheSenderAddress',
        'inTheRecipientAddress',
        'inTheMessageHeader',
        // Marked with
        'withImportance',
        'sensitivity',
        // Message includes
        // 'classification',
        'flag',
        'type',
        'attachment',
        // Message size
        'atLeast',
        'atMost',
        // Received
        'before',
        'after',
    ];
}
exports.default = getConditionalExceptionClauseTypeOptions;
//# sourceMappingURL=getConditionalExceptionClauseTypeOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/getConditionalExceptionClauseTypeOptions.js
// module id = 2796
// module chunks = 2 90